import PropTypes from 'prop-types';

export default function OutlineDashboard(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M8.222 2H2v6.222h6.222V2ZM18 2h-6.222v6.222H18V2ZM18 11.778h-6.222V18H18v-6.222ZM8.222 11.778H2V18h6.222v-6.222Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineDashboard.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
